import request from '@/utils/request'

const jobApi = {
  getDetails: 'jobPosition/getDetails',
  shareConfig: 'share/shareConfig',
  collect: 'jobPosition/collect',
  enroll: 'jobPosition/enroll',
  getSelectedJobId: 'jobPosition/getSelectedJobId',
  getRealExamList: 'exam/getRealExamList',
  setSelectedJobId: 'jobPosition/setSelectedJobId',

  courseList: 'course.course/list',
  providerList: 'provider/list',
  regionList: 'course.course/regionList',

  collectionList: 'Sk/collectionList',
  zkRegion: 'Sk/zkRegion',
  zkMajor: 'Sk/zkMajor',
  zkDeucate: 'Sk/zkDeucate',
  zkSubject: 'Sk/zkSubject',
  collectionZkLis: 'Sk/collectionZkList',
  getZkExamList:'Sk/getZkExamList'
  
}
export function getZkExamList(parameter) {
  return request({
    url: jobApi.getZkExamList,
    method: 'get',
    params: parameter
  })
}
// 自考课程包
export function collectionZkLis(parameter) {
  return request({
    url: jobApi.collectionZkLis,
    method: 'get',
    params: parameter
  })
}
// 分类
export function zkSubject(parameter) {
  return request({
    url: jobApi.zkSubject,
    method: 'get',
    params: parameter
  })
}
export function zkDeucate(parameter) {
  return request({
    url: jobApi.zkDeucate,
    method: 'get',
    params: parameter
  })
}
export function zkMajor(parameter) {
  return request({
    url: jobApi.zkMajor,
    method: 'get',
    params: parameter
  })
}
export function zkRegion(parameter) {
  return request({
    url: jobApi.zkRegion,
    method: 'get',
    params: parameter
  })
}
// 课程包列表
export function collectionList(parameter) {
  return request({
    url: jobApi.collectionList,
    method: 'get',
    params: parameter
  })
}

// 课程列表
export function regionList(parameter) {
  return request({
    url: jobApi.regionList,
    method: 'get',
    params: parameter
  })
}
// 课程列表
export function courseList(parameter) {
  return request({
    url: jobApi.courseList,
    method: 'get',
    params: parameter
  })
}

// 机构列表
export function providerList(parameter) {
  return request({
    url: jobApi.providerList,
    method: 'get',
    params: parameter
  })
}
export function setSelectedJobId(parameter) {
  return request({
    url: jobApi.setSelectedJobId,
    method: 'get',
    params: parameter
  })
}

export function getRealExamList(parameter) {
  return request({
    url: jobApi.getRealExamList,
    method: 'get',
    params: parameter
  })
}

export function getSelectedJobId(parameter) {
  return request({
    url: jobApi.getSelectedJobId,
    method: 'get',
    params: parameter
  })
}

export function enroll(parameter) {
  return request({
    url: jobApi.enroll,
    method: 'post',
    data: parameter
  })
}

export function collect(parameter) {
  return request({
    url: jobApi.collect,
    method: 'post',
    data: parameter
  })
}

export function shareConfig(parameter) {
  return request({
    url: jobApi.shareConfig,
    method: 'get',
    params: parameter
  })
}

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function getDetails(parameter) {
  return request({
    url: jobApi.getDetails,
    method: 'get',
    params: parameter
  })
}
